import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import InsuredOccupation from '../../coverNotePVComponent/insuredOccupation/InsuredOccupation';
import DrivingExperience from '../../coverNotePVComponent/drivingExperience/DrivingExperience';
import Age from '../../coverNotePVComponent/age/Age';
import HirePurchaseOwner from '../../coverNotePVComponent/hirePurchaseOwner/HirePurchaseOwner';
import NameDrivers from '../../coverNotePVComponent/nameDrivers/NameDrivers';

class InsuredAndDriverInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">Insured and Driver Information</h3>
          <FormGroup controlId="">
            <Col sm={6}>
              <InsuredOccupation
                insuredOccupation={this.props.insuredAndDriverInfo.insuredOccupation}
                handleChangeInsuredOccupation={this.props.handleChangeInsuredAndDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <DrivingExperience
                drivingExperience={this.props.insuredAndDriverInfo.drivingExperience}
                handleChangeDrivingExperience={this.props.handleChangeInsuredAndDriverInfo}
                validation={this.props.validation}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <Age
                age={this.props.insuredAndDriverInfo.age}
                handleChangeAge={this.props.handleChangeInsuredAndDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <HirePurchaseOwner
                hirePurchaseOwner={this.props.insuredAndDriverInfo.hirePurchaseOwner}
                handleChangeHirePurchaseOwner={this.props.handleChangeInsuredAndDriverInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <NameDrivers
                nameDrivers={this.props.insuredAndDriverInfo.nameDrivers}
                handleChangeNameDrivers={this.props.handleChangeInsuredAndDriverInfo}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
      </div>
    )
  }
}

InsuredAndDriverInfo.propTypes = {
  insuredAndDriverInfo: PropTypes.object,
  handleChangeInsuredAndDriverInfo: PropTypes.func,
  validation: PropTypes.func
};

export default InsuredAndDriverInfo;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/insuredAndDriverInfo/InsuredAndDriverInfo.js